export default __webpack_public_path__ + "0ffe3c4466a624dd9f21553bfb60ab7d.png";